import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import RegulationsPanel from './RegulationsPanel';

export default function RegulationsDialog({ open, onClose, country, type, code }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-3 md:p-6 overflow-y-auto">
      <div
        className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm animate-fade-in-up"
        style={{ animationDuration: '0.2s' }}
        onClick={onClose}
      />
      <div
        className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl my-4 overflow-hidden animate-fade-in-up"
        style={{ animationDuration: '0.25s' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white shadow-md hover:bg-slate-50 flex items-center justify-center transition-colors"
        >
          <X size={16} className="text-slate-600" />
        </button>
        <div className="p-1.5">
          <RegulationsPanel country={country} type={type} code={code} />
        </div>
      </div>
    </div>
  );
}
